export default __webpack_public_path__ + "static/media/ic-unverified-location-small.4fb0cf46.svg";